import { observable, computed } from "mobx";
import TriagemService from "../../../../services/TriagemService";
import _ from "lodash";
import {Col} from "reactstrap";
import AgendItem from "../components/AgendItem";
import React from "react";

export default class TriagemStore {

    @observable agendamentos;
    @observable paginaAtual;
    @observable itensNaPagina;
    @observable filtro;
    @observable loading;
    @observable buscaVazia;
    @observable buscaSemParametro;
    @observable total

    constructor() {
        this.agendamentos = [];
        this.paginaAtual = 0;
        this.itensNaPagina = 20;
        this.filtros = [];
        this.filtro = "";
        this.loading = false;
        this.buscaVazia = false;
        this.buscaSemParametro = false;
        this.filtrado = false;
        this.total = null

        this.filtrosTela = {}
        this.filtrosTela.placaCavalo = null;
        this.filtrosTela.cnh = null;

        this.service = new TriagemService();
    }

    @computed get numeroPaginas(){
        return Math.ceil(this.agendamentos.length / this.itensNaPagina) ;
    }

    listarAgendamentos = () => {
        let itens = [];

        if(_.get(this, "agendamentos")) {
            let lista = this.agendamentos;
            lista.slice(
                this.paginaAtual * this.itensNaPagina,
                (this.paginaAtual + 1) * this.itensNaPagina
            ).forEach((c, i) => {
                itens.push(
                    <Col xl={3} lg={6} md={6}
                    className="col-5x-2">
                        <AgendItem key={i + this.paginaAtual*this.numeroPaginas} agend={c} controller={this.service} filtros={this.filtrosTela}/>
                    </Col>
                    );
            })
        }

        return itens;
    };
    
    adicionarFiltro = (campoBusca, valor) => {
        let minValor
        if(typeof(valor) === 'string'){
            minValor = valor.toUpperCase()
            minValor = minValor.replace(/[ ]/g,'')
        }else{
            minValor = valor
        }
        this.filtros[campoBusca] = minValor;
        this.filtro = "";        
        if(this.filtros['placaCavalo'])
        {
            this.filtro += "placaCavalo="+this.filtros['placaCavalo']+"&";
            this.filtrosTela.placaCavalo = this.filtros['placaCavalo'];
        }
        if(this.filtros['cnh'])
        { 
            this.filtro += "cnh="+this.filtros['cnh']+"&";
            this.filtrosTela.cnh = this.filtros['cnh'];
        }
                
        this.filtro = this.filtro.substr(0, this.filtro.length-1);
    };

    limpar = () => {
        this.adicionarFiltro("placaCavalo", null);
        this.adicionarFiltro("cnh", null);
        this.listar();
    }
    
    listar = (e) => {
        this.filtrado = true;
        this.loading= true;

        if(_.isEmpty(this.filtro)){
            this.filtrado = false
            this.loading = false;
            this.buscaSemParametro = true;
            this.buscaVazia = false;
            return;
        }else{
            this.buscaSemParametro = false;
        }

        const loadingPromises = Promise.all([
            this.service.listar(this.filtro).then((response) => {
                this.agendamentos = response.data;
                this.total = response.data.length
                if(response.data.length>0) {
                    this.buscaVazia = false;
                }else {
                    this.filtrado = false
                    this.buscaVazia = true;
                    this.buscaSemParametro = false;
                }
            }).catch(error => {
                console.log(error);
            }),
        ]);
        loadingPromises.then(
            () => this.loading = false
        ).catch(
            () => this.loading = false
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/agendamento/depot-triagem/stores/TriagemStore.js